module.exports = __webpack_public_path__ + "static/img/9fd081ea75b309792f4adffb3553d2e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/workflow_active_02.png
// module id = giBe
// module chunks = 1